import { render, staticRenderFns } from "./ConnectionsTable.vue?vue&type=template&id=205a1d51&"
import script from "./ConnectionsTable.vue?vue&type=script&lang=js&"
export * from "./ConnectionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports